import React from 'react'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import List from '@taglivros/oef_componentes/build/components/list'

import Link from '../../components/Link/Link'
import blueArrow from '../../assets/imagens/arrow-blue.svg'
import { URLS } from '../../constants'

const Titulo = styled.h1`
  ${StyleGuide.tipografia.titulo1};
  margin: 25px 0 22px 0;
`

const AssinaturaPresente = () => {
  const links = [
    {
      'handleOnClick': () => {},
      'route': `/${URLS.ASSINATURA_PRESENTE_RESGATE}`,
      'subtitle': `Recebeu um presente? Use o código para descobrir o que é!`,
      'title': `Resgate presente`
    }
  ]

  return (
    <>
      <Titulo>
        Assinatura Presente
      </Titulo>

      <List
        className="listPlano"
        itemPadding={ StyleGuide.isMobile() ? '20px' : '20px 40px' }
        items={ links }
        maxWidth="unset"
      >
        {
          links.map( ( link ) => (
            <li
              key={ link.route }
              onClick={ link.handleOnClick }
            >
              <Link to={ link.route }>
                <div>
                  <h3>
                    { link.title }
                  </h3>

                  <span>
                    { link.subtitle }
                  </span>
                </div>

                <img
                  alt="flecha"
                  src={ blueArrow }
                />
              </Link>
            </li>
          ) )
        }
      </List>
    </>
  )
}

export default AssinaturaPresente
